<ng-container *ngIf="vm.sessionIsVerified(); else loading">
  <router-outlet></router-outlet>
</ng-container>
<ng-template #loading>
  <app-spinner></app-spinner>
</ng-template>
